import { render, staticRenderFns } from "./RemRefresh.vue?vue&type=template&id=06b9bfa5&"
import script from "./RemRefresh.vue?vue&type=script&lang=js&"
export * from "./RemRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports